import { render, staticRenderFns } from "./ProjectAddComponentModal.vue?vue&type=template&id=77e834bc&scoped=true&"
import script from "./ProjectAddComponentModal.vue?vue&type=script&lang=js&"
export * from "./ProjectAddComponentModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAddComponentModal.vue?vue&type=style&index=0&id=77e834bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e834bc",
  null
  
)

export default component.exports